/* LUIS RAFAEL v3 — Theme JS */
(function(){
  'use strict';

  /* ── Helpers ───────────────────────────────── */
  const $ = (s,c=document) => c.querySelector(s);
  const $$ = (s,c=document) => [...c.querySelectorAll(s)];

  /* ── Header scroll ─────────────────────────── */
  const hdr = $('.site-header');
  if(hdr){
    const f = () => hdr.classList.toggle('scrolled', window.scrollY > 30);
    window.addEventListener('scroll', f, {passive:true});
    f();
  }

  /* ── Overlay ───────────────────────────────── */
  const ov = $('#overlay');

  /* ── Mobile nav ────────────────────────────── */
  const mnav = $('.mobile-nav');
  const ham  = $('.header__hamburger');
  const mnc  = $('.mobile-nav__close');

  function openNav(){ mnav?.classList.add('open'); ov?.classList.add('active'); document.body.classList.add('locked'); }
  function closeNav(){ mnav?.classList.remove('open'); ov?.classList.remove('active'); document.body.classList.remove('locked'); }

  ham?.addEventListener('click', openNav);
  mnc?.addEventListener('click', closeNav);

  /* ── Search ────────────────────────────────── */
  const sp = $('#search-panel');
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', () => {
    sp?.classList.add('open');
    document.body.classList.add('locked');
    setTimeout(() => $('#search-input')?.focus(), 80);
  }));
  $('#search-close')?.addEventListener('click', closeSearch);
  function closeSearch(){ sp?.classList.remove('open'); document.body.classList.remove('locked'); }

  /* ── Cart drawer ───────────────────────────── */
  const cd = $('.cart-drawer');

  function openCart(){
    cd?.classList.add('open');
    ov?.classList.add('active');
    document.body.classList.add('locked');
  }
  function closeCart(){
    cd?.classList.remove('open');
    ov?.classList.remove('active');
    document.body.classList.remove('locked');
  }

  window.openCart  = openCart;
  window.closeCart = closeCart;

  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));

  ov?.addEventListener('click', () => { closeNav(); closeCart(); closeSearch(); });

  /* ── Cart API helpers ──────────────────────── */
  function fetchCart(){ return fetch('/cart.js').then(r => r.json()); }

  function formatMoney(cents){
    return (cents / 100).toLocaleString('nl-NL', {style:'currency', currency:'EUR'});
  }

  function updateCartCounts(cart){
    $$('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.add('bump');
      setTimeout(() => el.classList.remove('bump'), 400);
    });
    $$('[data-cart-subtotal]').forEach(el => el.textContent = formatMoney(cart.total_price));
  }

  function renderDrawerItems(cart){
    const body = $('#cart-drawer-body');
    if(!body) return;

    if(cart.item_count === 0){
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Nothing here yet</p>
          <button class="btn--text" onclick="closeCart()">Continue browsing</button>
        </div>`;
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        ${item.image
          ? `<img src="${item.image}" alt="${item.product_title}" class="cart-item__img" loading="lazy">`
          : `<div class="cart-item__img"></div>`}
        <div class="cart-item__info">
          <div>
            <div class="cart-item__name">${item.product_title.toUpperCase()}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
            <div class="cart-item__price">${formatMoney(item.line_price)}</div>
          </div>
          <button class="cart-item__remove" data-key="${item.key}">Remove</button>
        </div>
      </div>`).join('');

    // Remove item handlers
    $$('[data-key]', body).forEach(btn => {
      btn.addEventListener('click', () => {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({id: btn.dataset.key, quantity: 0})
        })
        .then(r => r.json())
        .then(cart => {
          updateCartCounts(cart);
          renderDrawerItems(cart);
        });
      });
    });
  }

  async function refreshCart(){
    const cart = await fetchCart();
    updateCartCounts(cart);
    renderDrawerItems(cart);
  }

  /* ── Scroll reveal ─────────────────────────── */
  const ro = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if(e.isIntersecting){ e.target.classList.add('in'); ro.unobserve(e.target); }
    });
  }, {threshold:0.08, rootMargin:'0px 0px -48px 0px'});
  $$('.reveal').forEach(el => ro.observe(el));

  /* ── Newsletter ────────────────────────────── */
  $$('.newsletter__form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input   = form.querySelector('.newsletter__input');
      const success = form.closest('.newsletter')?.querySelector('.newsletter__success');
      if(!input?.value) return;
      if(success){ success.style.display = 'block'; form.style.display = 'none'; }
    });
  });

  /* ── ESC ───────────────────────────────────── */
  document.addEventListener('keydown', e => {
    if(e.key === 'Escape'){ closeNav(); closeSearch(); closeCart(); }
  });

  /* ── Init cart count on load ───────────────── */
  fetchCart().then(cart => {
    updateCartCounts(cart);
  }).catch(() => {});

})();
